export const theme = {
  colors: {
    primary: '#D9552E',
    secondary: '#FFFFFF',
    dark_gray: '#1E232A',
    gray: '#76868E',
    gray_2: '#88969D',
    light_gray: '#F4F5F6', 
  }
}

export type AppTheme = typeof theme;